import { render } from "./Dash.vue?vue&type=template&id=3c2514c6&scoped=true"
import script from "./Dash.vue?vue&type=script&lang=js"
export * from "./Dash.vue?vue&type=script&lang=js"

import "./Dash.vue?vue&type=style&index=0&id=3c2514c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2514c6"]])

export default __exports__